export enum ViewFilterType {
  topicView = 0,
  unitView = 1,
  activityView = 2,
}
